import Dexie from "dexie";
import db from "../Db";

var DeleteCendre = Dexie.async(function* () {
  yield db.open();
  yield db.CENDRE.clear();
});

export default DeleteCendre;
